<template>
  <div class="relative flex shrink-0 items-center justify-center">
    <BaseMemberAvatar :member="member" :size="size" />
    <div
      v-if="isChecked"
      class="absolute -right-1 -bottom-1 flex h-6 w-6 items-center justify-center"
    >
      <BaseIcon size="14" :filled="true" class="text-on-tertiary-container z-20">check</BaseIcon>
      <BaseShape
        shape="soft-burst"
        class="text-tertiary-container stroke-tertiary stroke-2 absolute right-0 z-10 h-full w-full"
      />
    </div>
  </div>
</template>
<script lang="ts" setup>
  import BaseIcon from '../icon/BaseIcon.vue'
  import BaseShape from '../shapes/BaseShape.vue'
  import type { AvatarMemberAttributes, AvatarSize } from './avatar-props'
  import BaseMemberAvatar from './BaseMemberAvatar.vue'

  interface Props {
    member: AvatarMemberAttributes
    isChecked: boolean
    size?: AvatarSize
  }

  defineProps<Props>()
</script>
